/* doc lang */
export const DOC_LANG = {
    EN: "en",
    ZH: "zh",
};

// doc theme
// export const DOC_THEME = {
//     DEFAULT: "default",
//     DARK: "dark",
// };

// doc lang cookie
export const DOC_LANG_COOKIE = "doc_lang_cookie";

// doc theme cookie
export const DOC_THEME_COOKIE = "doc_lang_cookie";
